import React from 'react';
import { useParams } from 'react-router-dom'; 
import Layout from '../../components/UI/Layout/Layout'
import ItemPage from '../../components/Entity/Cars/ListDealer/DealerCarPage'; 

const DealerCarPage = () => {  
  const { id } = useParams(); 
  return <Layout fullwidth={0} ><ItemPage id={id} ></ItemPage> </Layout >    ;
}

export default DealerCarPage;